module.exports = __webpack_public_path__ + "img/image.b0f8907d.svg";